import { apiService } from "@/services";
import { settings } from "@/settings";
import { FiscalYearsClient } from "./GeneratedClients";

const fiscalYearRepository = new FiscalYearsClient(settings.webApi.baseUrl, apiService.getApiClient());

export { fiscalYearRepository };
